import type { RouteRecordRaw } from 'vue-router'

import type { RedirectRouteRelative } from '@/utilities/routers'

import { routeBuyingCenterRoleSettingsRoot } from './buyingCenterRoleRoutes'
import {
  routeQuotationLostReasonHome,
  routeQuotationLostReasonRoot,
} from './quotationLostReasonRoutes'

const routeSalesSettingsHome: RouteRecordRaw = routeQuotationLostReasonHome

const routeSalesSettingsRoot: RouteRecordRaw = {
  children: [
    routeSalesSettingsHome,
    routeQuotationLostReasonRoot,
    routeBuyingCenterRoleSettingsRoot,
  ],
  path: 'sales',
}

const redirectSalesSettings: RedirectRouteRelative = {
  name: routeSalesSettingsHome.name,
}

export { redirectSalesSettings, routeSalesSettingsHome, routeSalesSettingsRoot }
